module.exports = __webpack_public_path__ + "img/6.1a0dbfc7.jpg";